import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import {
  getMessagesSync,
  getStoredLocale,
  setStoredLocale,
  t as translate,
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
} from '../i18n/arbLoader';

const LocaleContext = createContext(null);

export function LocaleProvider({ children }) {
  const [locale, setLocaleState] = useState(() => getStoredLocale());
  const [messages, setMessages] = useState(() => getMessagesSync(getStoredLocale()));

  const setLocale = useCallback((newLocale) => {
    if (!SUPPORTED_LOCALES.includes(newLocale)) return;
    setStoredLocale(newLocale);
    setLocaleState(newLocale);
    setMessages(getMessagesSync(newLocale));
  }, []);

  useEffect(() => {
    setMessages(getMessagesSync(locale));
  }, [locale]);

  const t = useCallback(
    (key, params) => translate(messages, key, params),
    [messages]
  );

  const value = {
    locale,
    setLocale,
    messages,
    t,
    loading: false,
    SUPPORTED_LOCALES,
  };

  return (
    <LocaleContext.Provider value={value}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useLocale() {
  const ctx = useContext(LocaleContext);
  if (!ctx) {
    throw new Error('useLocale must be used within LocaleProvider');
  }
  return ctx;
}
